/** TRITAL Care® — genuine client-notified requisition snapshots.
 * The weekly travel gross figures shown here were expressly approved by
 * company leadership on Nov 4, 2026 for qualified candidates on the stated
 * guaranteed-hours assignment. No private VMS remit rates, supplier details,
 * client identifiers, or internal cost and margin calculations are included.
 * A notice is NOT proof of current VMS availability; check before submitting
 * to a client. Local positions and other hours have separate written terms.
 */
export const PRIORITY_REQUISITIONS = Object.freeze([
  {
    "id": "tc-requisition-001",
    "slug": "travel-rn-outpatient-infusion-utica-ny-001",
    "title": "RN — Outpatient Infusion",
    "city": "Utica",
    "state": "NY",
    "stateName": "New York",
    "category": "Nursing",
    "arrangement": "Travel",
    "unit": "Infusion / Oncology",
    "shift": "Days · 5 × 8",
    "startDate": "2026-11-30",
    "guaranteedHours": 40,
    "contractWeeks": 13,
    "minExperienceYears": 1,
    "requirements": "Current BLS, ACLS; chemotherapy certification; active NY RN license. Outpatient infusion experience.",
    "noticeDate": "2026-11-03",
    "sourceStatus": "Client requisition email received; live submission status not independently verified",
    "verifiedOpen": false,
    "isRequisition": true,
    "isRecurringPRN": false,
    "isSnapshotPRN": false,
    "approvedTravelWeeklyGross": 2550,
    "payApproval": "approved",
    "payBasis": "travel",
    "payApprovalDate": "2026-11-04",
    "payTerms": "For clinicians meeting all client-required experience, license, specialty skills, certifications, travel eligibility and stated guaranteed hours. Local assignments, overtime and benefits may have different written terms."
  },
  {
    "id": "tc-requisition-002",
    "slug": "travel-rn-emergency-department-utica-ny-002",
    "title": "RN — Emergency Department",
    "city": "Utica",
    "state": "NY",
    "stateName": "New York",
    "category": "Nursing",
    "arrangement": "Travel",
    "unit": "Emergency Department",
    "shift": "Variable · 12-hour shifts",
    "startDate": "2026-11-30",
    "guaranteedHours": 36,
    "contractWeeks": 13,
    "minExperienceYears": 2,
    "requirements": "Recent ED experience including pediatric ED; BLS, ACLS, PALS, NIHSS and TNCC in hand; active NY RN license.",
    "noticeDate": "2026-11-03",
    "sourceStatus": "Client requisition email received; live submission status not independently verified",
    "verifiedOpen": false,
    "isRequisition": true,
    "isRecurringPRN": false,
    "isSnapshotPRN": false,
    "approvedTravelWeeklyGross": 2125,
    "payApproval": "approved",
    "payBasis": "travel",
    "payApprovalDate": "2026-11-04",
    "payTerms": "For clinicians meeting all client-required experience, license, specialty skills, certifications, travel eligibility and stated guaranteed hours. Local assignments, overtime and benefits may have different written terms."
  },
  {
    "id": "tc-requisition-003",
    "slug": "travel-speech-language-pathologist-acute-care-utica-ny-003",
    "title": "Speech Language Pathologist — Acute Care",
    "city": "Utica",
    "state": "NY",
    "stateName": "New York",
    "category": "Therapy",
    "arrangement": "Travel",
    "unit": "Acute Care SLP",
    "shift": "Days · 8 hours",
    "startDate": "2026-11-30",
    "guaranteedHours": 40,
    "contractWeeks": 13,
    "minExperienceYears": null,
    "requirements": "NY state license, CCC (Certificate of Clinical Competence), completion of clinical fellowship year, BLS required; acute-care inpatient and VFSS experience preferred. Local assignments use a separate lower rate.",
    "noticeDate": "2026-11-03",
    "sourceStatus": "Client requisition email received; live submission status not independently verified",
    "verifiedOpen": false,
    "isRequisition": true,
    "isRecurringPRN": false,
    "isSnapshotPRN": false,
    "approvedTravelWeeklyGross": 2400,
    "payApproval": "approved",
    "payBasis": "travel",
    "payApprovalDate": "2026-11-04",
    "payTerms": "For clinicians meeting all client-required experience, license, specialty skills, certifications, travel eligibility and stated guaranteed hours. Local assignments, overtime and benefits may have different written terms."
  },
  {
    "id": "tc-requisition-004",
    "slug": "travel-rn-med-surg-telemetry-4-east-mattoon-il-004",
    "title": "RN — Med-Surg / Telemetry, 4 East",
    "city": "Mattoon",
    "state": "IL",
    "stateName": "Illinois",
    "category": "Nursing",
    "arrangement": "Travel",
    "unit": "4 East · Med-Surg Tele",
    "shift": "Nights · 12-hour shifts",
    "startDate": "2026-11-16",
    "guaranteedHours": 40,
    "contractWeeks": 13,
    "minExperienceYears": 2,
    "requirements": "Med-Surg Tele experience; BLS and ACLS. Travel only; permanent residence at least 50 miles away. Weekly schedule requires confirmation.",
    "noticeDate": "2026-10-27",
    "sourceStatus": "Client requisition email received; live submission status not independently verified",
    "verifiedOpen": false,
    "isRequisition": true,
    "isRecurringPRN": false,
    "isSnapshotPRN": false,
    "approvedTravelWeeklyGross": 2300,
    "payApproval": "approved",
    "payBasis": "travel",
    "payApprovalDate": "2026-11-04",
    "payTerms": "For clinicians meeting all client-required experience, license, specialty skills, certifications, travel eligibility and stated guaranteed hours. Local assignments, overtime and benefits may have different written terms."
  },
  {
    "id": "tc-requisition-005",
    "slug": "travel-rn-med-surg-telemetry-2-south-mattoon-il-005",
    "title": "RN — Med-Surg / Telemetry, 2 South",
    "city": "Mattoon",
    "state": "IL",
    "stateName": "Illinois",
    "category": "Nursing",
    "arrangement": "Travel",
    "unit": "2 South · Med-Surg Tele",
    "shift": "Nights · 12-hour shifts",
    "startDate": "2027-01-04",
    "guaranteedHours": 40,
    "contractWeeks": 13,
    "minExperienceYears": 2,
    "requirements": "Med-Surg Tele experience; BLS and ACLS. Travel only; permanent residence at least 50 miles away.",
    "noticeDate": "2026-10-27",
    "sourceStatus": "Client requisition email received; live submission status not independently verified",
    "verifiedOpen": false,
    "isRequisition": true,
    "isRecurringPRN": false,
    "isSnapshotPRN": false,
    "approvedTravelWeeklyGross": 2300,
    "payApproval": "approved",
    "payBasis": "travel",
    "payApprovalDate": "2026-11-04",
    "payTerms": "For clinicians meeting all client-required experience, license, specialty skills, certifications, travel eligibility and stated guaranteed hours. Local assignments, overtime and benefits may have different written terms."
  },
  {
    "id": "tc-requisition-006",
    "slug": "travel-rn-med-surg-telemetry-4-west-mattoon-il-006",
    "title": "RN — Med-Surg / Telemetry, 4 West",
    "city": "Mattoon",
    "state": "IL",
    "stateName": "Illinois",
    "category": "Nursing",
    "arrangement": "Travel",
    "unit": "4 West · Med-Surg Tele",
    "shift": "Nights · 12-hour shifts",
    "startDate": "2026-11-16",
    "guaranteedHours": null,
    "contractWeeks": 13,
    "minExperienceYears": 2,
    "requirements": "BLS and ACLS; BiPAP/high-flow oxygen experience. Travel only. Weekly guaranteed hours must be reconfirmed.",
    "proposedWeeklyPay": null,
    "noticeDate": "2026-10-29",
    "sourceStatus": "Client requisition email received; live submission status not independently verified",
    "verifiedOpen": false,
    "isRequisition": true,
    "isRecurringPRN": false,
    "isSnapshotPRN": false,
    "payApproval": "approved",
    "payBasis": "travel",
    "payApprovalDate": "2026-11-04",
    "payTerms": "For clinicians meeting all client-required experience, license, specialty skills, certifications, travel eligibility and stated guaranteed hours. Local assignments, overtime and benefits may have different written terms."
  },
  {
    "id": "tc-requisition-007",
    "slug": "travel-rn-med-surg-oncology-8th-floor-utica-ny-007",
    "title": "RN — Med-Surg / Oncology, 8th Floor",
    "city": "Utica",
    "state": "NY",
    "stateName": "New York",
    "category": "Nursing",
    "arrangement": "Travel",
    "unit": "8th Floor · Med-Surg / Oncology",
    "shift": "Nights · 6:30 PM–7 AM",
    "startDate": "2026-11-30",
    "guaranteedHours": 36,
    "contractWeeks": 13,
    "minExperienceYears": 2,
    "requirements": "NY RN license, BLS, NIHSS, Epic and prior travel experience. Local applicants considered under a different rate.",
    "noticeDate": "2026-11-03",
    "sourceStatus": "Client requisition email received; live submission status not independently verified",
    "verifiedOpen": false,
    "isRequisition": true,
    "isRecurringPRN": false,
    "isSnapshotPRN": false,
    "approvedTravelWeeklyGross": 1975,
    "payApproval": "approved",
    "payBasis": "travel",
    "payApprovalDate": "2026-11-04",
    "payTerms": "For clinicians meeting all client-required experience, license, specialty skills, certifications, travel eligibility and stated guaranteed hours. Local assignments, overtime and benefits may have different written terms."
  },
  {
    "id": "tc-requisition-008",
    "slug": "travel-rn-med-surg-7th-floor-utica-ny-008",
    "title": "RN — Med-Surg, 7th Floor",
    "city": "Utica",
    "state": "NY",
    "stateName": "New York",
    "category": "Nursing",
    "arrangement": "Travel",
    "unit": "7th Floor · Med-Surg",
    "shift": "Nights · 6:30 PM–7:00 AM",
    "startDate": "2026-11-23",
    "guaranteedHours": 36,
    "contractWeeks": 13,
    "minExperienceYears": 2,
    "requirements": "2+ years Med-Surg with stroke stepdown, prior travel experience, active NY RN license, AHA BLS, NIHSS and Epic; locals within 75 miles have a separate rate.",
    "noticeDate": "2026-11-02",
    "sourceStatus": "Client requisition email received; live submission status not independently verified",
    "verifiedOpen": false,
    "isRequisition": true,
    "isRecurringPRN": false,
    "isSnapshotPRN": false,
    "approvedTravelWeeklyGross": 1975,
    "payApproval": "approved",
    "payBasis": "travel",
    "payApprovalDate": "2026-11-04",
    "payTerms": "For clinicians meeting all client-required experience, license, specialty skills, certifications, travel eligibility and stated guaranteed hours. Local assignments, overtime and benefits may have different written terms."
  },
  {
    "id": "tc-requisition-009",
    "slug": "travel-rn-med-surg-6th-floor-utica-ny-009",
    "title": "RN — Med-Surg, 6th Floor",
    "city": "Utica",
    "state": "NY",
    "stateName": "New York",
    "category": "Nursing",
    "arrangement": "Travel",
    "unit": "6th Floor · Med-Surg",
    "shift": "Nights · 6:30 PM–7:00 AM",
    "startDate": "2026-11-23",
    "guaranteedHours": 36,
    "contractWeeks": 13,
    "minExperienceYears": 2,
    "requirements": "2+ years recent Med-Surg, documented travel experience, active NY RN license, current AHA BLS and Epic; floating required; locals within 75 miles have a separate rate.",
    "noticeDate": "2026-10-29",
    "sourceStatus": "Client requisition email received; live submission status not independently verified",
    "verifiedOpen": false,
    "isRequisition": true,
    "isRecurringPRN": false,
    "isSnapshotPRN": false,
    "approvedTravelWeeklyGross": 1975,
    "payApproval": "approved",
    "payBasis": "travel",
    "payApprovalDate": "2026-11-04",
    "payTerms": "For clinicians meeting all client-required experience, license, specialty skills, certifications, travel eligibility and stated guaranteed hours. Local assignments, overtime and benefits may have different written terms."
  },
  {
    "id": "tc-requisition-010",
    "slug": "travel-rn-long-term-care-med-surg-vandalia-il-010",
    "title": "RN — Long-Term Care / Med-Surg",
    "city": "Vandalia",
    "state": "IL",
    "stateName": "Illinois",
    "category": "Nursing",
    "arrangement": "Travel",
    "unit": "Long-Term Care Unit",
    "shift": "Nights · 6:00 PM–6:00 AM",
    "startDate": "2026-11-23",
    "guaranteedHours": 40,
    "contractWeeks": 13,
    "minExperienceYears": null,
    "requirements": "Illinois RN license and BLS required; long-term care RN with weekend and holiday rotation. Client did not specify minimum years in the notification.",
    "noticeDate": "2026-11-02",
    "sourceStatus": "Client requisition email received; live submission status not independently verified",
    "verifiedOpen": false,
    "isRequisition": true,
    "isRecurringPRN": false,
    "isSnapshotPRN": false,
    "approvedTravelWeeklyGross": 2200,
    "payApproval": "approved",
    "payBasis": "travel",
    "payApprovalDate": "2026-11-04",
    "payTerms": "For clinicians meeting all client-required experience, license, specialty skills, certifications, travel eligibility and stated guaranteed hours. Local assignments, overtime and benefits may have different written terms."
  },
  {
    "id": "tc-requisition-011",
    "slug": "travel-rn-progressive-care-mpcu-cape-coral-fl-011",
    "title": "RN — Progressive Care, MPCU",
    "city": "Cape Coral",
    "state": "FL",
    "stateName": "Florida",
    "category": "Nursing",
    "arrangement": "Travel",
    "unit": "MPCU · Progressive Care",
    "shift": "36-hour schedule",
    "startDate": "2026-12-04",
    "guaranteedHours": 36,
    "contractWeeks": 13,
    "minExperienceYears": 2,
    "requirements": "Recent PCU experience, BLS, ACLS, NIHSS, drips; floating required and 50-mile travel radius.",
    "noticeDate": "2026-11-03",
    "sourceStatus": "Client requisition email received; live submission status not independently verified",
    "verifiedOpen": false,
    "isRequisition": true,
    "isRecurringPRN": false,
    "isSnapshotPRN": false,
    "approvedTravelWeeklyGross": 1800,
    "payApproval": "approved",
    "payBasis": "travel",
    "payApprovalDate": "2026-11-04",
    "payTerms": "For clinicians meeting all client-required experience, license, specialty skills, certifications, travel eligibility and stated guaranteed hours. Local assignments, overtime and benefits may have different written terms."
  },
  {
    "id": "tc-requisition-012",
    "slug": "travel-rn-progressive-care-mpcu-2nd-requisition-cape-coral-fl-012",
    "title": "RN — Progressive Care, MPCU (2nd requisition)",
    "city": "Cape Coral",
    "state": "FL",
    "stateName": "Florida",
    "category": "Nursing",
    "arrangement": "Travel",
    "unit": "MPCU · Progressive Care",
    "shift": "36-hour schedule",
    "startDate": "2026-12-04",
    "guaranteedHours": 36,
    "contractWeeks": 13,
    "minExperienceYears": 2,
    "requirements": "Separate client requisition; PCU experience, BLS, ACLS, NIHSS, drips; floating required.",
    "noticeDate": "2026-11-03",
    "sourceStatus": "Client requisition email received; live submission status not independently verified",
    "verifiedOpen": false,
    "isRequisition": true,
    "isRecurringPRN": false,
    "isSnapshotPRN": false,
    "approvedTravelWeeklyGross": 1800,
    "payApproval": "approved",
    "payBasis": "travel",
    "payApprovalDate": "2026-11-04",
    "payTerms": "For clinicians meeting all client-required experience, license, specialty skills, certifications, travel eligibility and stated guaranteed hours. Local assignments, overtime and benefits may have different written terms."
  },
  {
    "id": "tc-requisition-013",
    "slug": "travel-rn-med-surg-neurology-atlanta-ga-013",
    "title": "RN — Med-Surg, Neurology",
    "city": "Atlanta",
    "state": "GA",
    "stateName": "Georgia",
    "category": "Nursing",
    "arrangement": "Travel",
    "unit": "7A Neurology",
    "shift": "Schedule verified with recruiter",
    "startDate": "2026-11-16",
    "guaranteedHours": 36,
    "contractWeeks": 13,
    "minExperienceYears": 2,
    "requirements": "2+ years specialty experience; neuro skills and NIHSS required. EPIC and ACLS required for strong Med-Surg/stepdown alternative; weekend coverage and no block scheduling.",
    "noticeDate": "2026-11-02",
    "sourceStatus": "Client requisition email received; live submission status not independently verified",
    "verifiedOpen": false,
    "isRequisition": true,
    "isRecurringPRN": false,
    "isSnapshotPRN": false,
    "approvedTravelWeeklyGross": 1625,
    "payApproval": "approved",
    "payBasis": "travel",
    "payApprovalDate": "2026-11-04",
    "payTerms": "For clinicians meeting all client-required experience, license, specialty skills, certifications, travel eligibility and stated guaranteed hours. Local assignments, overtime and benefits may have different written terms."
  },
  {
    "id": "tc-requisition-014",
    "slug": "travel-rn-med-surg-surgical-trauma-atlanta-ga-014",
    "title": "RN — Med-Surg, Surgical Trauma",
    "city": "Atlanta",
    "state": "GA",
    "stateName": "Georgia",
    "category": "Nursing",
    "arrangement": "Travel",
    "unit": "6B Surgery Trauma",
    "shift": "Schedule verified with recruiter",
    "startDate": "2026-11-16",
    "guaranteedHours": 36,
    "contractWeeks": 13,
    "minExperienceYears": 2,
    "requirements": "2+ years specialty experience; high-acuity surgery/trauma background, BLS, Epic, ACLS preferred; no block scheduling or planned time off.",
    "noticeDate": "2026-10-23",
    "sourceStatus": "Client requisition email received; live submission status not independently verified",
    "verifiedOpen": false,
    "isRequisition": true,
    "isRecurringPRN": false,
    "isSnapshotPRN": false,
    "approvedTravelWeeklyGross": 1625,
    "payApproval": "approved",
    "payBasis": "travel",
    "payApprovalDate": "2026-11-04",
    "payTerms": "For clinicians meeting all client-required experience, license, specialty skills, certifications, travel eligibility and stated guaranteed hours. Local assignments, overtime and benefits may have different written terms."
  },
  {
    "id": "tc-requisition-015",
    "slug": "travel-rn-med-surg-dedicated-education-unit-atlanta-ga-015",
    "title": "RN — Med-Surg, Dedicated Education Unit",
    "city": "Atlanta",
    "state": "GA",
    "stateName": "Georgia",
    "category": "Nursing",
    "arrangement": "Travel",
    "unit": "9CD Med-Surg",
    "shift": "Schedule verified with recruiter",
    "startDate": "2026-11-16",
    "guaranteedHours": 36,
    "contractWeeks": 13,
    "minExperienceYears": 2,
    "requirements": "Direct patient care, not teaching. Med-Surg experience, BLS; ACLS preferred.",
    "noticeDate": "2026-10-23",
    "sourceStatus": "Client requisition email received; live submission status not independently verified",
    "verifiedOpen": false,
    "isRequisition": true,
    "isRecurringPRN": false,
    "isSnapshotPRN": false,
    "approvedTravelWeeklyGross": 1625,
    "payApproval": "approved",
    "payBasis": "travel",
    "payApprovalDate": "2026-11-04",
    "payTerms": "For clinicians meeting all client-required experience, license, specialty skills, certifications, travel eligibility and stated guaranteed hours. Local assignments, overtime and benefits may have different written terms."
  },
  {
    "id": "tc-requisition-016",
    "slug": "travel-rn-med-surg-telemetry-surgical-ace-atlanta-ga-016",
    "title": "RN — Med-Surg / Telemetry, Surgical ACE",
    "city": "Atlanta",
    "state": "GA",
    "stateName": "Georgia",
    "category": "Nursing",
    "arrangement": "Travel",
    "unit": "5A Surgical ACE",
    "shift": "Schedule verified with recruiter",
    "startDate": "2026-11-16",
    "guaranteedHours": 36,
    "contractWeeks": 13,
    "minExperienceYears": null,
    "requirements": "Documented Med-Surg/Telemetry experience; BLS, ACLS and Epic required. Geriatric/trauma/ortho-trauma experience useful; minimum years not stated in source notice.",
    "noticeDate": "2026-10-29",
    "sourceStatus": "Client requisition email received; live submission status not independently verified",
    "verifiedOpen": false,
    "isRequisition": true,
    "isRecurringPRN": false,
    "isSnapshotPRN": false,
    "approvedTravelWeeklyGross": 1625,
    "payApproval": "approved",
    "payBasis": "travel",
    "payApprovalDate": "2026-11-04",
    "payTerms": "For clinicians meeting all client-required experience, license, specialty skills, certifications, travel eligibility and stated guaranteed hours. Local assignments, overtime and benefits may have different written terms."
  },
  {
    "id": "tc-requisition-017",
    "slug": "travel-rn-med-surg-hematology-oncology-atlanta-ga-017",
    "title": "RN — Med-Surg, Hematology / Oncology",
    "city": "Atlanta",
    "state": "GA",
    "stateName": "Georgia",
    "category": "Nursing",
    "arrangement": "Travel",
    "unit": "10A Hem / Oncology",
    "shift": "Schedule verified with recruiter",
    "startDate": "2026-11-16",
    "guaranteedHours": 36,
    "contractWeeks": 13,
    "minExperienceYears": 2,
    "requirements": "2+ years Med-Surg/Oncology in a similar-size setting; Epic and unit skill checklist required, chemotherapy certification preferred; no planned time off.",
    "noticeDate": "2026-10-21",
    "sourceStatus": "Client requisition email received; live submission status not independently verified",
    "verifiedOpen": false,
    "isRequisition": true,
    "isRecurringPRN": false,
    "isSnapshotPRN": false,
    "approvedTravelWeeklyGross": 1625,
    "payApproval": "approved",
    "payBasis": "travel",
    "payApprovalDate": "2026-11-04",
    "payTerms": "For clinicians meeting all client-required experience, license, specialty skills, certifications, travel eligibility and stated guaranteed hours. Local assignments, overtime and benefits may have different written terms."
  },
  {
    "id": "tc-requisition-018",
    "slug": "travel-rn-med-surg-acute-neuro-nights-atlanta-ga-018",
    "title": "RN — Med-Surg, Acute Neuro (Nights)",
    "city": "Atlanta",
    "state": "GA",
    "stateName": "Georgia",
    "category": "Nursing",
    "arrangement": "Travel",
    "unit": "Acute Neuro Unit",
    "shift": "Nights · 3 × 12",
    "startDate": "2026-11-09",
    "guaranteedHours": 36,
    "contractWeeks": 13,
    "minExperienceYears": 2,
    "requirements": "BLS required; ACLS preferred. Travel only; holiday availability requirements apply. Rate needs latest VMS confirmation.",
    "noticeDate": "2026-10-22",
    "sourceStatus": "Client requisition email received; live submission status not independently verified",
    "verifiedOpen": false,
    "isRequisition": true,
    "isRecurringPRN": false,
    "isSnapshotPRN": false,
    "approvedTravelWeeklyGross": 1625,
    "payApproval": "approved",
    "payBasis": "travel",
    "payApprovalDate": "2026-11-04",
    "payTerms": "For clinicians meeting all client-required experience, license, specialty skills, certifications, travel eligibility and stated guaranteed hours. Local assignments, overtime and benefits may have different written terms."
  },
  {
    "id": "tc-requisition-019",
    "slug": "travel-rn-med-surg-acute-neuro-days-atlanta-ga-019",
    "title": "RN — Med-Surg, Acute Neuro (Days)",
    "city": "Atlanta",
    "state": "GA",
    "stateName": "Georgia",
    "category": "Nursing",
    "arrangement": "Travel",
    "unit": "Acute Neuro Unit",
    "shift": "Days · 3 × 12",
    "startDate": "2026-11-09",
    "guaranteedHours": 36,
    "contractWeeks": 13,
    "minExperienceYears": 2,
    "requirements": "BLS required; ACLS preferred. Travel only; rate needs latest VMS confirmation.",
    "noticeDate": "2026-10-22",
    "sourceStatus": "Client requisition email received; live submission status not independently verified",
    "verifiedOpen": false,
    "isRequisition": true,
    "isRecurringPRN": false,
    "isSnapshotPRN": false,
    "approvedTravelWeeklyGross": 1625,
    "payApproval": "approved",
    "payBasis": "travel",
    "payApprovalDate": "2026-11-04",
    "payTerms": "For clinicians meeting all client-required experience, license, specialty skills, certifications, travel eligibility and stated guaranteed hours. Local assignments, overtime and benefits may have different written terms."
  },
  {
    "id": "tc-requisition-020",
    "slug": "travel-rn-med-surg-acute-gi-nights-atlanta-ga-020",
    "title": "RN — Med-Surg, Acute GI (Nights)",
    "city": "Atlanta",
    "state": "GA",
    "stateName": "Georgia",
    "category": "Nursing",
    "arrangement": "Travel",
    "unit": "Acute GI Medicine Unit",
    "shift": "Nights · 3 × 12",
    "startDate": "2026-11-16",
    "guaranteedHours": 36,
    "contractWeeks": 13,
    "minExperienceYears": 2,
    "requirements": "Recent specialty experience, BLS and NIHSS; travel only, no local candidates within 50 miles.",
    "noticeDate": "2026-10-29",
    "sourceStatus": "Client requisition email received; live submission status not independently verified",
    "verifiedOpen": false,
    "isRequisition": true,
    "isRecurringPRN": false,
    "isSnapshotPRN": false,
    "approvedTravelWeeklyGross": 1375,
    "payApproval": "approved",
    "payBasis": "travel",
    "payApprovalDate": "2026-11-04",
    "payTerms": "For clinicians meeting all client-required experience, license, specialty skills, certifications, travel eligibility and stated guaranteed hours. Local assignments, overtime and benefits may have different written terms."
  },
  {
    "id": "tc-requisition-021",
    "slug": "travel-rn-med-surg-acute-gi-2nd-requisition-atlanta-ga-021",
    "title": "RN — Med-Surg, Acute GI (2nd requisition)",
    "city": "Atlanta",
    "state": "GA",
    "stateName": "Georgia",
    "category": "Nursing",
    "arrangement": "Travel",
    "unit": "Acute GI Medicine Unit",
    "shift": "Nights · 3 × 12",
    "startDate": "2026-11-16",
    "guaranteedHours": 36,
    "contractWeeks": 13,
    "minExperienceYears": 2,
    "requirements": "Separate client requisition; recent Med-Surg experience, BLS/NIHSS; travel only.",
    "noticeDate": "2026-10-28",
    "sourceStatus": "Client requisition email received; live submission status not independently verified",
    "verifiedOpen": false,
    "isRequisition": true,
    "isRecurringPRN": false,
    "isSnapshotPRN": false,
    "approvedTravelWeeklyGross": 1375,
    "payApproval": "approved",
    "payBasis": "travel",
    "payApprovalDate": "2026-11-04",
    "payTerms": "For clinicians meeting all client-required experience, license, specialty skills, certifications, travel eligibility and stated guaranteed hours. Local assignments, overtime and benefits may have different written terms."
  },
  {
    "id": "tc-requisition-022",
    "slug": "travel-rn-med-surg-acute-gi-additional-opening-atlanta-ga-022",
    "title": "RN — Med-Surg, Acute GI (Additional Opening)",
    "city": "Atlanta",
    "state": "GA",
    "stateName": "Georgia",
    "category": "Nursing",
    "arrangement": "Travel",
    "unit": "Acute GI Medicine Unit",
    "shift": "Days · 7:00 AM–7:00 PM",
    "startDate": "2026-11-09",
    "guaranteedHours": 36,
    "contractWeeks": 13,
    "minExperienceYears": 2,
    "requirements": "2+ years within Med-Surg specialty, BLS and NIHSS required, ACLS preferred. No local candidates within 50 miles; holiday coverage rules apply.",
    "noticeDate": "2026-10-21",
    "sourceStatus": "Client requisition email received; live submission status not independently verified",
    "verifiedOpen": false,
    "isRequisition": true,
    "isRecurringPRN": false,
    "isSnapshotPRN": false,
    "approvedTravelWeeklyGross": 1375,
    "payApproval": "approved",
    "payBasis": "travel",
    "payApprovalDate": "2026-11-04",
    "payTerms": "For clinicians meeting all client-required experience, license, specialty skills, certifications, travel eligibility and stated guaranteed hours. Local assignments, overtime and benefits may have different written terms."
  },
  {
    "id": "tc-requisition-023",
    "slug": "travel-rn-med-surg-acute-cardiology-atlanta-ga-023",
    "title": "RN — Med-Surg, Acute Cardiology",
    "city": "Atlanta",
    "state": "GA",
    "stateName": "Georgia",
    "category": "Nursing",
    "arrangement": "Travel",
    "unit": "Acute Cardiology Unit",
    "shift": "Nights · 7:00 PM–7:00 AM",
    "startDate": "2026-11-09",
    "guaranteedHours": 36,
    "contractWeeks": 13,
    "minExperienceYears": 2,
    "requirements": "2+ years recent Med-Surg/Cardiology, AHA BLS, ACLS and NIHSS required; every-other-weekend work, holiday availability and 50-mile travel rule.",
    "noticeDate": "2026-10-21",
    "sourceStatus": "Client requisition email received; live submission status not independently verified",
    "verifiedOpen": false,
    "isRequisition": true,
    "isRecurringPRN": false,
    "isSnapshotPRN": false,
    "approvedTravelWeeklyGross": 1375,
    "payApproval": "approved",
    "payBasis": "travel",
    "payApprovalDate": "2026-11-04",
    "payTerms": "For clinicians meeting all client-required experience, license, specialty skills, certifications, travel eligibility and stated guaranteed hours. Local assignments, overtime and benefits may have different written terms."
  },
  {
    "id": "tc-requisition-024",
    "slug": "travel-rn-med-surg-acute-medicine-lawrenceville-ga-024",
    "title": "RN — Med-Surg, Acute Medicine",
    "city": "Lawrenceville",
    "state": "GA",
    "stateName": "Georgia",
    "category": "Nursing",
    "arrangement": "Travel",
    "unit": "Acute Medicine Unit",
    "shift": "Nights · 7:00 PM–7:00 AM",
    "startDate": "2026-11-16",
    "guaranteedHours": 36,
    "contractWeeks": 13,
    "minExperienceYears": null,
    "requirements": "Acute Medicine RN, AHA BLS, 50-mile travel radius and holiday availability. The source notice omitted the numerical minimum years; confirm before submission.",
    "noticeDate": "2026-10-28",
    "sourceStatus": "Client requisition email received; live submission status not independently verified",
    "verifiedOpen": false,
    "isRequisition": true,
    "isRecurringPRN": false,
    "isSnapshotPRN": false,
    "approvedTravelWeeklyGross": 1375,
    "payApproval": "approved",
    "payBasis": "travel",
    "payApprovalDate": "2026-11-04",
    "payTerms": "For clinicians meeting all client-required experience, license, specialty skills, certifications, travel eligibility and stated guaranteed hours. Local assignments, overtime and benefits may have different written terms."
  },
  {
    "id": "tc-requisition-025",
    "slug": "travel-rn-med-surg-acute-medicine-duluth-ga-025",
    "title": "RN — Med-Surg, Acute Medicine",
    "city": "Duluth",
    "state": "GA",
    "stateName": "Georgia",
    "category": "Nursing",
    "arrangement": "Travel",
    "unit": "Acute Medicine Unit",
    "shift": "Days · 7:00 AM–7:00 PM",
    "startDate": "2026-11-09",
    "guaranteedHours": 36,
    "contractWeeks": 13,
    "minExperienceYears": 2,
    "requirements": "2+ years recent Med-Surg, AHA BLS required, ACLS preferred. No local candidates within 50 miles; holiday availability required.",
    "noticeDate": "2026-10-21",
    "sourceStatus": "Client requisition email received; live submission status not independently verified",
    "verifiedOpen": false,
    "isRequisition": true,
    "isRecurringPRN": false,
    "isSnapshotPRN": false,
    "approvedTravelWeeklyGross": 1375,
    "payApproval": "approved",
    "payBasis": "travel",
    "payApprovalDate": "2026-11-04",
    "payTerms": "For clinicians meeting all client-required experience, license, specialty skills, certifications, travel eligibility and stated guaranteed hours. Local assignments, overtime and benefits may have different written terms."
  },
  {
    "id": "tc-requisition-026",
    "slug": "travel-rn-operating-room-trauma-atlanta-ga-026",
    "title": "RN — Operating Room / Trauma",
    "city": "Atlanta",
    "state": "GA",
    "stateName": "Georgia",
    "category": "Nursing",
    "unit": "Operating Room · Level I Trauma",
    "shift": "Shift/call/weekends per unit schedule",
    "startDate": "2026-12-07",
    "guaranteedHours": 36,
    "contractWeeks": 13,
    "minExperienceYears": null,
    "requirements": "Previous travel and Level I trauma experience required. Strong operating-room clinical skills, including neuro and vascular procedures; call, weekends and holidays required. No block scheduling. Specialty credential requirements confirmed with recruiter.",
    "noticeDate": "2026-11-02",
    "arrangement": "Travel",
    "approvedTravelWeeklyGross": 1750,
    "sourceStatus": "Client email says open at notice time; present submission status not independently verified",
    "verifiedOpen": false,
    "isRequisition": true,
    "isRecurringPRN": false,
    "isSnapshotPRN": false,
    "payApproval": "approved",
    "payBasis": "travel",
    "payApprovalDate": "2026-11-03",
    "payTerms": "CEO approved travel weekly gross for candidates meeting client experience, active credentials, skills and travel eligibility at stated hours. Local/overtime/benefits have separate written terms."
  },
  {
    "id": "tc-requisition-028",
    "slug": "travel-rn-med-surg-telemetry-float-concord-ma-028",
    "title": "RN — Med-Surg / Telemetry Float",
    "city": "Concord",
    "state": "MA",
    "stateName": "Massachusetts",
    "category": "Nursing",
    "unit": "Float Pool · Med-Surg / Telemetry",
    "shift": "Nights · 7:00 PM–7:30 AM · every other weekend",
    "startDate": "2026-11-17",
    "guaranteedHours": 36,
    "contractWeeks": 13,
    "minExperienceYears": 3,
    "requirements": "3+ years acute-care Med-Surg/Telemetry and prior travel RN experience; Massachusetts RN license and BLS. Meditech preferred; every-other-holiday schedule and Christmas Eve/Day availability; separate local rate.",
    "noticeDate": "2026-11-02",
    "arrangement": "Travel",
    "approvedTravelWeeklyGross": 2100,
    "sourceStatus": "Client email says open at notice time; present submission status not independently verified",
    "verifiedOpen": false,
    "isRequisition": true,
    "isRecurringPRN": false,
    "isSnapshotPRN": false,
    "payApproval": "approved",
    "payBasis": "travel",
    "payApprovalDate": "2026-11-03",
    "payTerms": "CEO approved travel weekly gross for candidates meeting client experience, active credentials, skills and travel eligibility at stated hours. Local/overtime/benefits have separate written terms."
  },
  {
    "id": "tc-requisition-029",
    "slug": "travel-rn-pcu-emergency-holding-float-cape-coral-fl-029",
    "title": "RN — PCU / Emergency Holding Float",
    "city": "Cape Coral",
    "state": "FL",
    "stateName": "Florida",
    "category": "Nursing",
    "unit": "Progressive Care / ED Holding",
    "shift": "36 hours/week · flexible floating",
    "startDate": "2027-01-08",
    "guaranteedHours": 36,
    "contractWeeks": 13,
    "minExperienceYears": 2,
    "requirements": "2+ years PCU and actual ED holding experience (ED staffing experience not required); BLS, ACLS, NIHSS; Florida/Compact license, Epic and floating including sister campuses; 50-mile travel rule.",
    "noticeDate": "2026-11-02",
    "arrangement": "Travel",
    "approvedTravelWeeklyGross": 1800,
    "sourceStatus": "Client email says open at notice time; present submission status not independently verified",
    "verifiedOpen": false,
    "isRequisition": true,
    "isRecurringPRN": false,
    "isSnapshotPRN": false,
    "payApproval": "approved",
    "payBasis": "travel",
    "payApprovalDate": "2026-11-03",
    "payTerms": "CEO approved travel weekly gross for candidates meeting client experience, active credentials, skills and travel eligibility at stated hours. Local/overtime/benefits have separate written terms."
  },
  {
    "id": "tc-requisition-030",
    "slug": "travel-rn-pcu-emergency-holding-float-fort-myers-fl-030",
    "title": "RN — PCU / Emergency Holding Float",
    "city": "Fort Myers",
    "state": "FL",
    "stateName": "Florida",
    "category": "Nursing",
    "unit": "Progressive Care / ED Holding",
    "shift": "36 hours/week · floating required",
    "startDate": "2026-12-11",
    "guaranteedHours": 36,
    "contractWeeks": 13,
    "minExperienceYears": 2,
    "requirements": "2+ years PCU, BLS, ACLS, NIHSS and appropriate Florida/Compact RN license. Epic experience; ED Holding/PCU float assignment, 50-mile travel rule and floating across campuses. Degree-accreditation or 5-year experience documentation as required.",
    "noticeDate": "2026-11-02",
    "arrangement": "Travel",
    "approvedTravelWeeklyGross": 1800,
    "sourceStatus": "Client email says open at notice time; present submission status not independently verified",
    "verifiedOpen": false,
    "isRequisition": true,
    "isRecurringPRN": false,
    "isSnapshotPRN": false,
    "payApproval": "approved",
    "payBasis": "travel",
    "payApprovalDate": "2026-11-03",
    "payTerms": "CEO approved travel weekly gross for candidates meeting client experience, active credentials, skills and travel eligibility at stated hours. Local/overtime/benefits have separate written terms."
  },
  {
    "id": "tc-requisition-031",
    "slug": "travel-rn-operating-room-circulator-mattoon-il-031",
    "title": "RN — Operating Room Circulator",
    "city": "Mattoon",
    "state": "IL",
    "stateName": "Illinois",
    "category": "Nursing",
    "unit": "Operating Room",
    "shift": "Days · 4 × 10 · 6:30 AM–5:00 PM; on call",
    "startDate": "2026-11-23",
    "guaranteedHours": 40,
    "contractWeeks": 13,
    "minExperienceYears": 2,
    "requirements": "2+ years circulating OR RN experience, Illinois RN license, BLS and ACLS; approximately 2–3 call shifts per month; travel candidates outside 50-mile radius. Illinois-specific benefits and compensation disclosures must be confirmed.",
    "noticeDate": "2026-11-02",
    "arrangement": "Travel",
    "approvedTravelWeeklyGross": 2175,
    "sourceStatus": "Client email says open at notice time; present submission status not independently verified",
    "verifiedOpen": false,
    "isRequisition": true,
    "isRecurringPRN": false,
    "isSnapshotPRN": false,
    "payApproval": "approved",
    "payBasis": "travel",
    "payApprovalDate": "2026-11-03",
    "payTerms": "CEO approved travel weekly gross for candidates meeting client experience, active credentials, skills and travel eligibility at stated hours. Local/overtime/benefits have separate written terms."
  },
  {
    "id": "tc-requisition-032",
    "slug": "travel-certified-occupational-therapy-assistant-snf-flagstaff-az-032",
    "title": "Certified Occupational Therapy Assistant — SNF",
    "city": "Flagstaff",
    "state": "AZ",
    "stateName": "Arizona",
    "category": "Therapy",
    "unit": "Skilled Nursing / Assisted Living",
    "shift": "Days · 5 days/week · 32 guaranteed hours",
    "startDate": "2026-11-23",
    "guaranteedHours": 32,
    "contractWeeks": 13,
    "minExperienceYears": null,
    "requirements": "Arizona COTA license and fingerprint clearance card or qualifying pending-license evidence; SNF/assisted living patient care; 32 guaranteed hours. Client may consider less-experienced clinicians at an adjusted client rate, subject to separate qualification and pay approval.",
    "noticeDate": "2026-11-03",
    "arrangement": "Travel",
    "approvedTravelWeeklyGross": 850,
    "sourceStatus": "Client email says open at notice time; present submission status not independently verified",
    "verifiedOpen": false,
    "isRequisition": true,
    "isRecurringPRN": false,
    "isSnapshotPRN": false,
    "payApproval": "approved",
    "payBasis": "travel",
    "payApprovalDate": "2026-11-03",
    "payTerms": "CEO approved travel weekly gross for candidates meeting client experience, active credentials, skills and travel eligibility at stated hours. Local/overtime/benefits have separate written terms."
  }
]);
